import { render, staticRenderFns } from "./BattleBonus.vue?vue&type=template&id=6ee1bb72&scoped=true&"
import script from "./BattleBonus.vue?vue&type=script&lang=js&"
export * from "./BattleBonus.vue?vue&type=script&lang=js&"
import style0 from "./BattleBonus.vue?vue&type=style&index=0&id=6ee1bb72&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee1bb72",
  null
  
)

export default component.exports